import { SvgIcon, SvgIconProps } from "@mui/material";

export const WeightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M18.3811 9.81324L14.3267 6.13965C13.8562 5.71401 13.0723 5.73653 12.6243 6.18449L8.95075 9.83573C7.67387 11.1126 6.95715 12.8373 7.00199 14.6517C7.02433 16.4661 7.76354 18.1686 9.0851 19.4229C10.3171 20.5877 11.9523 21.2149 13.6771 21.2149C15.4019 21.2149 17.0371 20.5654 18.2691 19.4006C19.5907 18.1462 20.3299 16.4437 20.3522 14.6294C20.3971 12.8374 19.7025 11.1125 18.381 9.81341L18.3811 9.81324ZM17.1939 18.2804C16.2531 19.1763 14.9987 19.6468 13.677 19.6468C12.3555 19.6468 11.1011 19.154 10.1601 18.2804C9.15219 17.3173 8.56966 16.0181 8.54734 14.6292C8.525 13.2404 9.06251 11.9187 10.0481 10.9333L13.4753 7.50609L17.2833 10.9333C18.2689 11.9189 18.8064 13.2405 18.7841 14.6292C18.7844 16.0181 18.2244 17.3173 17.1939 18.2804H17.1939Z"
        fill="white"
      />
      <path
        d="M16.6564 11.5822L13.834 9.02856C13.7219 8.91653 13.5427 9.00622 13.5427 9.16294V18.6381C13.5427 18.7277 13.6323 18.8173 13.7219 18.8173C14.1476 18.8173 14.5732 18.7502 14.9763 18.5933C18.1796 17.4061 18.7396 13.6653 16.6563 11.5821L16.6564 11.5822Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const AgeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M19.74 20.018H8.26002C7.92586 20.018 7.6054 19.8852 7.36908 19.6489C7.13275 19.4126 7 19.0921 7 18.7579V10.3342C7 10.0001 7.13274 9.67955 7.36908 9.4433C7.6054 9.20697 7.92586 9.07422 8.26002 9.07422H19.74C20.0741 9.07422 20.3946 9.20695 20.6309 9.4433C20.8672 9.67955 21 10.0001 21 10.3342V18.7595C20.9996 19.0934 20.8667 19.4135 20.6304 19.6495C20.3942 19.8855 20.0739 20.018 19.74 20.018Z"
        fill="white"
      />
      <path
        d="M9.20792 10.2732C9.11508 10.2732 9.02605 10.2363 8.96041 10.1707C8.89484 10.1051 8.85791 10.0161 8.85791 9.92323V8.22504C8.85791 8.10001 8.92466 7.98447 9.03291 7.92195C9.14125 7.85935 9.27465 7.85935 9.38293 7.92195C9.49127 7.98446 9.55793 8.1 9.55793 8.22504V9.92323C9.55793 10.0161 9.52108 10.1051 9.45543 10.1707C9.38979 10.2363 9.30076 10.2732 9.20792 10.2732H9.20792Z"
        fill="white"
      />
      <path
        d="M18.5458 10.2732C18.453 10.2732 18.3639 10.2363 18.2983 10.1707C18.2327 10.1051 18.1958 10.0161 18.1958 9.92323V8.22504C18.1958 8.10001 18.2625 7.98447 18.3708 7.92195C18.4791 7.85935 18.6125 7.85935 18.7208 7.92195C18.8291 7.98446 18.8958 8.1 18.8958 8.22504V9.92323C18.8958 10.0161 18.859 10.1051 18.7933 10.1707C18.7277 10.2363 18.6387 10.2732 18.5458 10.2732H18.5458Z"
        fill="white"
      />
      <path
        d="M21.4795 12.25H6.52054C6.37926 12.25 6.2486 12.1667 6.17798 12.0312C6.10734 11.8959 6.10734 11.7291 6.17798 11.5937C6.24862 11.4583 6.37927 11.375 6.52054 11.375H21.4795C21.6207 11.375 21.7514 11.4583 21.822 11.5937C21.8927 11.7291 21.8927 11.8959 21.822 12.0312C21.7514 12.1667 21.6207 12.25 21.4795 12.25Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const HeightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M18.1776 6.04075C17.9019 5.76506 17.453 5.76506 17.1773 6.04075L16.5375 6.68051L17.7181 7.86103C17.8559 7.99887 17.8559 8.22154 17.7181 8.3594C17.6474 8.43009 17.559 8.4619 17.4671 8.4619C17.3752 8.4619 17.2869 8.42656 17.2162 8.3594L16.0356 7.17888L13.9998 9.21476L15.6363 10.8513C15.7741 10.9891 15.7741 11.2118 15.6363 11.3496C15.5656 11.4203 15.4772 11.4521 15.3853 11.4521C15.2934 11.4521 15.2051 11.4168 15.1344 11.3496L13.4979 9.71314L11.462 11.749L12.6425 12.9295C12.7803 13.0674 12.7803 13.2901 12.6425 13.4279C12.5718 13.4986 12.4834 13.5304 12.3916 13.5304C12.2997 13.5304 12.2113 13.4951 12.1406 13.4279L10.9672 12.2509L8.93127 14.2868L10.5678 15.9233C10.7056 16.0611 10.7056 16.2838 10.5678 16.4217C10.4971 16.4924 10.4087 16.5242 10.3168 16.5242C10.2249 16.5242 10.1366 16.4888 10.0659 16.4217L8.42937 14.7852L6.04002 17.1745C5.76433 17.4502 5.76433 17.8991 6.04002 18.1748L8.6591 20.7939C8.9348 21.0696 9.38369 21.0696 9.65937 20.7939L20.7966 9.65662C21.0723 9.38092 21.0723 8.93203 20.7966 8.65635L18.1776 6.04075ZM8.91009 19.0442C8.8394 19.1149 8.75104 19.1468 8.65914 19.1468C8.56725 19.1468 8.47888 19.1114 8.40819 19.0442L7.78964 18.4257C7.65179 18.2878 7.65179 18.0652 7.78964 17.9273C7.92749 17.7895 8.15015 17.7895 8.28801 17.9273L8.90656 18.5459C9.04795 18.6837 9.04795 18.9064 8.9101 19.0442H8.91009Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const StrongFootIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M19.1397 19.5692C19.1732 19.5831 19.2083 19.5925 19.2441 19.5971C19.4801 19.66 19.7256 19.5354 19.8145 19.3079C19.9035 19.0806 19.8074 18.8225 19.5917 18.7085L6.47481 11.7666C6.72488 11.2968 7.02798 10.7316 7.42754 10.0658C8.60907 8.05858 9.89154 7.8455 10.0333 7.8263C10.2761 7.79606 10.5026 7.95308 10.5596 8.19094C10.6145 8.42243 10.6563 8.65687 10.6845 8.89309C10.7091 9.022 10.7812 9.13722 10.8865 9.21557C10.9361 9.24385 12.7263 10.243 13.517 10.6038C13.8862 10.7747 14.9414 10.2871 15.5558 9.86776C15.6634 9.79465 15.7959 9.76817 15.9234 9.79464C16.0507 9.82062 16.162 9.89727 16.2319 10.0067L17.3284 11.7123L15.244 12.7295L15.2438 12.7294C15.0061 12.8463 14.9081 13.1336 15.0245 13.3715C15.0854 13.4967 15.1975 13.5891 15.3318 13.6253C15.4435 13.655 15.5621 13.6438 15.666 13.5932L17.8531 12.5263L18.3561 13.3023L17.2913 13.8073C17.1106 13.8937 17.0025 14.083 17.0198 14.2823C17.0373 14.4817 17.1765 14.6495 17.3694 14.703C17.48 14.7329 17.5975 14.7219 17.7006 14.6726L18.88 14.1113C19.0895 14.4333 19.2752 14.7142 19.4091 14.9192C19.7971 15.448 20.2558 15.9212 20.7721 16.3257C21.7968 17.2042 22.9616 18.1997 22.1978 20.1599C22.0555 20.5876 21.7453 20.9388 21.3382 21.1325C20.9678 21.2835 20.5574 21.3065 20.1725 21.1979C20.1197 21.1875 20.0679 21.1737 20.017 21.1563L19.966 21.1426L7.04092 14.2918C6.63128 14.0706 6.31746 13.706 6.15963 13.2678C6.09942 13.0717 6.08438 12.8647 6.11576 12.6621L19.1397 19.5692Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const PostsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "14", height: "11", fill: "none" }}
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
    >
      <path
        d="M2.00697 2.32588V10.066C2.00697 10.3974 2.2756 10.666 2.60697 10.666L13.0668 10.6659C13.3982 10.6659 13.6668 10.3973 13.6668 10.0659V2.92579C13.6668 2.59442 13.3982 2.32579 13.0668 2.32579L2.00697 2.32588ZM12.8369 9.26465L11.1635 6.48914L9.27229 8.0674L7.83014 5.65921L2.83695 9.82248V3.15581H12.8369L12.8369 9.26465ZM3.66683 5.23744C3.66683 5.9313 4.22468 6.48914 4.91853 6.48914C5.61238 6.48914 6.17023 5.9313 6.17023 5.23744C6.17023 4.54359 5.61238 3.98574 4.91853 3.98574C4.22468 3.98574 3.66683 4.55717 3.66683 5.23744ZM11.9933 1.08093C11.9933 0.851773 11.8075 0.666016 11.5783 0.666016H0.933497C0.602126 0.666016 0.333496 0.934645 0.333496 1.26602V8.59119C0.333496 8.82036 0.519283 9.00615 0.748462 9.00615C0.977641 9.00615 1.16343 8.82036 1.16343 8.59119V1.49595H11.5783C11.8075 1.49595 11.9933 1.31013 11.9933 1.08093Z"
        fill="#008B07"
      />
    </SvgIcon>
  );
};

export const ExperienceIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "8", height: "32", fill: "none" }}
      width="8"
      height="32"
      viewBox="0 0 8 32"
      fill="none"
    >
      <rect x="3.5" width="1" height="20" fill="#E7E7E7" />
      <circle cx="4" cy="28" r="3.5" fill="#E7E7E7" stroke="#E7E7E7" />
    </SvgIcon>
  );
};

export const TrophyIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "38", height: "60", fill: "none" }}
      width="38"
      height="60"
      viewBox="0 0 38 60"
      fill="none"
    >
      <g clipPath="url(#clip0_30317_80295)">
        <path
          d="M35.5144 55.9437V51.635C35.5144 51.3817 35.2611 51.1279 35.0074 51.1279H27.2352C26.9819 51.1279 26.7281 50.8747 26.7281 50.6209V49.6917C26.7281 49.4384 26.4748 49.1847 26.2211 49.1847H25.6296C25.4608 49.1847 25.2919 49.1002 25.207 48.9314C23.9397 46.4815 23.0949 42.8487 23.0949 42.8487C21.0672 36.0057 27.8258 22.4044 30.6983 17.082C28.9243 20.1234 25.9674 22.4044 22.419 23.2491C22.2501 23.3335 22.0812 23.418 21.9964 23.6717C20.3077 33.3872 20.3077 44.3702 20.3921 48.6791C20.3921 48.9324 20.1388 49.1862 19.8851 49.1862H18.8714C18.6181 49.1862 18.3644 48.9329 18.3644 48.6791C18.4488 44.4548 18.4488 33.3877 16.9281 23.6728C16.9281 23.5039 16.7592 23.335 16.5055 23.2502C12.9571 22.4054 9.91581 20.1245 8.22624 17.0831C11.0987 22.4055 17.7729 35.9231 15.8296 42.8498C15.8296 42.8498 14.9848 46.4826 13.7175 48.9325C13.633 49.1013 13.4642 49.1858 13.2949 49.1858H11.8586C11.6053 49.1858 11.3516 49.4391 11.3516 49.6928V50.622C11.3516 50.8753 11.0983 51.129 10.8445 51.129H2.90427C2.65097 51.129 2.39723 51.3823 2.39723 51.6361V55.9448C2.39723 56.1981 2.14393 56.4518 1.8902 56.4518H0.70723C0.45393 56.4518 0.200195 56.7051 0.200195 56.9589V59.4932C0.200195 59.7465 0.453495 60.0002 0.70723 60.0002H37.2033C37.4566 60.0002 37.7103 59.7469 37.7103 59.4932V56.9589C37.7103 56.7056 37.457 56.4518 37.2033 56.4518H36.0203C35.7674 56.4514 35.5141 56.2825 35.5141 55.9444L35.5144 55.9437Z"
          fill="#CFCFCF"
        />
        <path
          d="M30.0229 9.81604C29.6003 4.57852 25.2915 0.354318 20.0537 0.0165118C13.8866 -0.321653 8.7334 4.57852 8.7334 10.6612C8.7334 16.1525 12.8728 20.63 18.1951 21.2215H18.9554C19.2932 21.2215 19.5469 21.3059 19.8846 21.3059C20.1379 21.2215 20.3917 21.2215 20.645 21.2215C26.221 20.63 30.5293 15.6454 30.0227 9.81647L30.0229 9.81604ZM19.5471 1.95939C19.8848 1.70609 20.223 1.53679 20.6451 1.36792C20.814 1.36792 20.9829 1.45235 21.1521 1.45235C21.2366 1.53679 21.321 1.70566 21.1521 1.7901C20.6451 2.29713 19.9692 2.466 19.5471 2.38156C19.3782 2.29755 19.3782 2.04382 19.5471 1.95939V1.95939ZM16.4214 2.21269C16.5058 2.12825 16.5902 2.12825 16.5902 2.04382C16.6747 1.95938 16.8435 1.95938 16.928 1.95938C17.1813 1.95938 17.435 1.95938 17.6883 2.04382C17.6883 2.04382 17.6883 1.95938 17.7727 1.95938L18.0265 2.12825C18.1109 2.21269 18.0265 2.38155 17.8576 2.46599C17.3505 2.63486 16.9284 2.88859 16.4213 2.55043C16.3369 2.46642 16.252 2.29755 16.4213 2.21269H16.4214ZM26.559 5.33886C25.9675 5.33886 25.5454 5.50773 25.2916 6.09919H25.2072C24.7002 5.93032 23.6865 5.00116 23.5176 4.49413C23.2643 3.56492 22.6729 2.97346 21.7437 2.88906C21.5748 2.88906 21.4904 3.05793 21.4904 3.2268C21.5748 3.31123 21.5748 3.39567 21.6592 3.4801C21.997 3.90269 22.4196 4.24044 22.7573 4.66307C22.8417 4.66307 22.8417 4.66307 22.7573 4.66307C22.4195 4.91637 22.0813 4.83194 21.7436 4.66307C21.4903 4.57864 21.2366 4.40977 21.321 4.07161C21.321 4.07161 21.2366 3.98717 21.2366 3.90274C21.0677 3.8183 20.9833 3.8183 20.814 3.73387C20.6451 3.64943 20.5607 3.73387 20.5607 3.90274C20.5607 4.15604 20.4763 4.40977 20.3918 4.57864C20.223 4.74751 19.9692 4.83194 19.7159 4.91638C19.6315 4.91638 19.5471 5.00082 19.5471 5.08525C19.5471 5.59229 19.7159 5.67672 20.4763 5.67672C20.5607 5.67672 20.6451 5.59229 20.7296 5.50785L20.814 4.91638C20.814 4.83195 20.9829 4.74751 21.0673 4.74751C21.6588 4.83195 22.1653 5.00081 22.6724 5.08525C22.7568 5.08525 22.8412 5.16969 22.8412 5.25413C23.0945 5.93003 23.6016 6.4371 24.1086 6.9437C24.2775 7.11257 24.3619 7.28144 24.2775 7.45073C24.2775 7.53517 24.1086 7.6196 24.0242 7.6196C23.1794 7.3663 22.4191 7.8729 21.8276 8.37994C21.1517 8.80253 20.6446 9.47797 20.3913 10.3232C20.3913 10.4077 20.2224 10.4921 20.138 10.4921C19.8847 10.4077 19.7154 10.4077 19.5465 10.2388C19.1239 9.98552 18.8706 10.2388 18.5329 10.4077C18.4485 10.4921 18.5329 10.7454 18.5329 10.9992C18.5329 11.0836 18.5329 11.168 18.6173 11.2525C18.7862 10.9992 19.0399 10.8299 19.2932 10.9147C19.3777 10.9147 19.4621 10.9991 19.4621 11.168L19.4625 11.4217C19.4625 11.5062 19.4625 11.5906 19.547 11.5906C19.8003 11.8439 20.054 12.0132 20.2229 12.1821C20.3073 12.2665 20.4762 12.2665 20.6455 12.2665C20.9832 12.2665 21.4058 12.1821 21.7435 12.2665C22.335 12.3509 22.9265 12.5198 23.5175 12.6042C23.6019 12.6042 23.7708 12.7731 23.8552 12.8575C24.2778 13.449 24.8688 13.8712 25.5448 14.2093C25.7136 14.2937 25.9674 14.4626 26.1362 14.5471C26.2207 14.6315 26.3051 14.7159 26.2207 14.8004C26.0518 15.1381 25.7981 15.4763 25.7136 15.814C25.4603 16.4899 25.0377 16.912 24.3619 17.1658C24.193 17.2502 24.0241 17.4191 24.0241 17.5884C23.8553 18.2643 23.4327 18.7713 22.7568 19.109C22.5879 19.1935 22.5035 19.3623 22.3342 19.3623C22.1653 19.4468 21.9964 19.6156 21.9116 19.7849C21.489 19.8694 21.0668 19.9538 20.6442 20.0382C20.5598 19.1935 20.8131 18.4331 20.9819 17.5883V17.1657C20.8131 16.3209 20.4749 15.4761 20.0527 14.8003C19.9683 14.6314 19.9683 14.4626 20.0527 14.2933C20.1372 13.9555 20.306 13.7018 20.4753 13.4485C20.5598 13.3641 20.4753 13.1952 20.3909 13.1952C20.1376 13.0263 19.8839 12.9419 19.715 12.7726C19.3773 12.4349 19.0391 12.1812 18.617 12.1812C17.9411 12.0967 17.3496 11.8434 17.1807 11.0831C17.1807 11.0831 17.0963 10.9987 17.0963 10.9143C17.0963 11.1676 17.0963 11.252 17.0118 11.5902C16.843 11.4213 16.7585 11.4213 16.6741 11.2524C16.3363 10.7454 15.9137 10.3232 15.5761 9.81614C15.4916 9.64727 15.4072 9.4784 15.4072 9.22468C15.4916 8.29547 15.3227 7.5351 14.7313 6.85927C14.6468 6.77484 14.5624 6.60597 14.5624 6.52153C14.478 6.26823 14.3091 6.26823 14.0554 6.26823C13.1262 6.35267 12.4503 6.35267 11.7748 6.4371C11.5215 6.4371 11.2678 6.35267 11.0145 6.26823C11.0989 6.01493 11.2678 5.84564 11.3522 5.67677C11.69 5.16973 12.1125 4.66313 12.5352 4.24049C12.8729 4.15606 13.2111 4.07162 13.5488 3.98719C14.3092 3.81832 14.9851 3.81832 15.6609 3.39573C15.7453 3.31129 15.9142 3.39573 15.9987 3.39573C16.5057 3.5646 17.0123 3.5646 17.4349 3.5646C17.942 3.5646 18.1953 3.39573 18.4486 2.97313C18.533 2.8887 18.7019 2.71983 18.7863 2.71983H20.307C20.814 2.71983 21.1517 2.6354 21.4899 2.2128C21.6588 1.9595 21.9125 1.7902 22.2503 1.70576C24.278 2.38167 25.9675 3.64907 27.15 5.25414C26.8967 5.339 26.7278 5.339 26.5589 5.339L26.559 5.33886Z"
          fill="#CFCFCF"
        />
      </g>
      <defs>
        <clipPath id="clip0_30317_80295">
          <rect width="38" height="60" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const OptionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.8462 12C16.8462 13.1046 17.776 14 18.9231 14C20.0701 14 21 13.1046 21 12C21 10.8954 20.0701 10 18.9231 10C17.776 10 16.8462 10.8954 16.8462 12Z"
        fill="#707070"
      />
      <path
        d="M12 14C10.8529 14 9.92308 13.1046 9.92308 12C9.92308 10.8954 10.8529 10 12 10C13.1471 10 14.0769 10.8954 14.0769 12C14.0769 13.1046 13.1471 14 12 14Z"
        fill="#707070"
      />
      <path
        d="M5.07692 14C3.92987 14 3 13.1046 3 12C3 10.8954 3.92987 10 5.07692 10C6.22398 10 7.15385 10.8954 7.15385 12C7.15385 13.1046 6.22398 14 5.07692 14Z"
        fill="#707070"
      />
    </SvgIcon>
  );
};

export const MediaSwipeRightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.1665 10H15.8332M15.8332 10L10.8332 5M15.8332 10L10.8332 15"
        stroke="#111111"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const MediaSwipeLeftIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.8335 10H4.16683M4.16683 10L9.16683 5M4.16683 10L9.16683 15"
        stroke="#111111"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const LocationsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.5" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M21.5 12.834C21.5 8.95465 18.2917 5.83398 14.5 5.83398C10.6207 5.83398 7.5 8.95482 7.5 12.834V13.1257C7.5 13.1548 7.61667 14.1757 7.73333 14.6132C8.55 18.0258 11.3207 20.6215 14.5 23.0425C17.6792 20.6217 20.45 18.0258 21.2667 14.6132C21.3833 14.1757 21.5 13.184 21.5 13.1257V12.834ZM14.5 15.7507C12.8958 15.7507 11.5833 14.4382 11.5833 12.834C11.5833 11.2298 12.8958 9.91732 14.5 9.91732C16.1042 9.91732 17.4167 11.2298 17.4167 12.834C17.4167 14.4382 16.1042 15.7507 14.5 15.7507Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const ScoutedPlayersIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M10.5412 7.00001C11.3429 6.99844 12.1124 7.31563 12.6801 7.8815C13.248 8.44749 13.5676 9.21598 13.5686 10.0177C13.5697 10.8195 13.252 11.5888 12.6857 12.1562C12.1193 12.7236 11.3507 13.0428 10.5489 13.0433C9.74723 13.0438 8.97824 12.7256 8.41105 12.1589C7.84399 11.5921 7.52539 10.8234 7.52539 10.0216C7.52539 9.22118 7.84296 8.45349 8.40831 7.8871C8.97381 7.32057 9.74086 7.00157 10.5412 7.00001Z"
        fill="white"
      />
      <path
        d="M5.83317 19.3032C5.83474 18.0552 6.3312 16.8587 7.21363 15.9763C8.09618 15.0937 9.29264 14.5973 10.5407 14.5957C11.7892 14.5932 12.9869 15.0911 13.8656 15.9783C14.1738 16.2836 14.4371 16.6313 14.6473 17.0108C15.0377 17.7133 15.2388 18.5053 15.2306 19.3091V21.6949H5.83301L5.83317 19.3032ZM22.1663 21.689H16.7181V19.3032C16.7168 19.0595 16.7013 18.816 16.6713 18.5741C16.6713 18.4983 16.6713 18.4224 16.6363 18.3466C16.6363 18.1833 16.578 18.0199 16.5429 17.8566C16.5079 17.6934 16.502 17.6875 16.4729 17.6C16.4437 17.5125 16.3795 17.2966 16.3212 17.1508C16.2629 17.0049 16.2629 16.9932 16.2337 16.9174L16.1987 16.8299H16.1989C16.9468 16.2784 17.8732 16.0248 18.7979 16.1181C19.7225 16.2116 20.5793 16.6454 21.2019 17.3354C21.8244 18.0254 22.1681 18.9223 22.1663 19.8516L22.1663 21.689Z"
        fill="white"
      />
      <path
        d="M18.4159 10.4238C19.0038 10.4238 19.5675 10.6574 19.9832 11.0732C20.3989 11.4888 20.6325 12.0526 20.6325 12.6405C20.6325 13.2284 20.3989 13.7923 19.9832 14.2079C19.5675 14.6236 19.0038 14.8571 18.4159 14.8571C17.828 14.8571 17.264 14.6237 16.8484 14.2079C16.4327 13.7923 16.1992 13.2283 16.1992 12.6405C16.2007 12.0531 16.4348 11.4902 16.8501 11.0749C17.2655 10.6595 17.8284 10.4254 18.4159 10.4238Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const RepresentedClubsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.5" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M21.773 9.38851L14.7329 5.8879C14.5886 5.81601 14.4222 5.81601 14.2779 5.8879L7.23777 9.38851C7.12897 9.44087 7.03928 9.53047 6.98247 9.64325C6.92565 9.75616 6.90498 9.88599 6.92372 10.0128L8.00681 17.0141C8.03099 17.1642 8.10872 17.2982 8.22343 17.3874L14.1805 22.0549C14.2732 22.128 14.3851 22.1673 14.4999 22.1673C14.6148 22.1673 14.7267 22.128 14.8194 22.0549L20.7765 17.3874C20.8912 17.2982 20.9689 17.1642 20.9931 17.0141L22.0762 10.0128C22.0958 9.88743 22.0767 9.7585 22.0219 9.64585C21.9671 9.53307 21.8797 9.44282 21.773 9.38851L21.773 9.38851ZM20.2729 11.0454L19.5038 16.022V16.0221C19.4796 16.1723 19.4019 16.3063 19.2872 16.3955L14.8248 19.8961C14.7321 19.9692 14.6202 20.0085 14.5053 20.0085C14.3905 20.0085 14.2786 19.9692 14.1859 19.8961L9.7235 16.3955C9.60879 16.3063 9.53106 16.1723 9.50689 16.0221L8.73782 11.0452C8.71873 10.9192 8.73855 10.7897 8.7944 10.6771C8.85012 10.5643 8.93873 10.4743 9.04655 10.421L14.2779 7.81888C14.4222 7.74699 14.5886 7.74699 14.7329 7.81888L19.9643 10.421H19.9641C20.072 10.4743 20.1606 10.5643 20.2163 10.6771C20.2721 10.7897 20.292 10.9192 20.2729 11.0452L20.2729 11.0454Z"
        fill="white"
      />
      <path
        d="M9.875 11.2909L10.541 15.5967L14.5052 18.7006L18.4693 15.5967L19.1354 11.2909L14.5053 8.99219L9.875 11.2909Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TotalRepresentedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M10.5412 7.00001C11.3429 6.99844 12.1124 7.31563 12.6801 7.8815C13.248 8.44749 13.5676 9.21598 13.5686 10.0177C13.5697 10.8195 13.252 11.5888 12.6857 12.1562C12.1193 12.7236 11.3507 13.0428 10.5489 13.0433C9.74723 13.0438 8.97824 12.7256 8.41105 12.1589C7.84399 11.5921 7.52539 10.8234 7.52539 10.0216C7.52539 9.22118 7.84296 8.45349 8.40831 7.8871C8.97381 7.32057 9.74086 7.00157 10.5412 7.00001Z"
        fill="white"
      />
      <path
        d="M5.83366 19.3032C5.83523 18.0552 6.33169 16.8587 7.21412 15.9763C8.09667 15.0937 9.29313 14.5973 10.5411 14.5957C11.7897 14.5932 12.9874 15.0911 13.8661 15.9783C14.1743 16.2836 14.4376 16.6313 14.6477 17.0108C15.0382 17.7133 15.2393 18.5053 15.2311 19.3091V21.6949H5.8335L5.83366 19.3032ZM22.1668 21.689H16.7185V19.3032C16.7172 19.0595 16.7018 18.816 16.6718 18.5741C16.6718 18.4983 16.6718 18.4224 16.6368 18.3466C16.6368 18.1833 16.5784 18.0199 16.5434 17.8566C16.5084 17.6934 16.5025 17.6875 16.4734 17.6C16.4442 17.5125 16.38 17.2966 16.3217 17.1508C16.2633 17.0049 16.2633 16.9932 16.2342 16.9174L16.1992 16.8299H16.1994C16.9473 16.2784 17.8737 16.0248 18.7984 16.1181C19.7229 16.2116 20.5798 16.6454 21.2024 17.3354C21.8249 18.0254 22.1686 18.9223 22.1668 19.8516L22.1668 21.689Z"
        fill="white"
      />
      <path
        d="M18.4164 10.4238C19.0042 10.4238 19.568 10.6574 19.9837 11.0732C20.3994 11.4888 20.633 12.0526 20.633 12.6405C20.633 13.2284 20.3994 13.7923 19.9837 14.2079C19.568 14.6236 19.0042 14.8571 18.4164 14.8571C17.8285 14.8571 17.2645 14.6237 16.8489 14.2079C16.4332 13.7923 16.1997 13.2283 16.1997 12.6405C16.2011 12.0531 16.4353 11.4902 16.8506 11.0749C17.266 10.6595 17.8289 10.4254 18.4164 10.4238Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const TotalCareerTransfersIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.5" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M18.2649 7.00139C18.1575 7.01423 18.0769 7.10533 18.0771 7.21333V9.74435H12.6094C12.4926 9.74502 12.3982 9.8395 12.3975 9.95628V12.881C12.3982 12.9978 12.4926 13.0923 12.6094 13.093H18.0771V15.624H18.0773C18.0794 15.7091 18.1321 15.7847 18.2112 15.8162C18.2901 15.8478 18.3804 15.8294 18.4407 15.7693L22.6067 11.5669C22.6869 11.4844 22.6869 11.353 22.6067 11.2703L18.4407 7.06205C18.3945 7.0161 18.3297 6.99379 18.265 7.0015L18.2649 7.00139ZM10.6899 11.7549C10.6418 11.7601 10.597 11.7814 10.5626 11.8155L6.39662 16.0178C6.3562 16.0578 6.3335 16.1123 6.3335 16.1692C6.3335 16.226 6.3562 16.2806 6.39662 16.3206L10.5626 20.5229C10.6237 20.5836 10.7154 20.6014 10.7948 20.5683C10.8742 20.5352 10.9259 20.4576 10.9259 20.3715V17.8464H16.394C16.5108 17.8459 16.6052 17.7513 16.6059 17.6345V14.7099C16.6073 14.6527 16.5855 14.5974 16.5456 14.5565C16.5058 14.5155 16.4512 14.4921 16.394 14.4919H10.9259V11.9668V11.9669C10.9259 11.9063 10.9003 11.8486 10.8552 11.8082C10.8102 11.7678 10.7501 11.7485 10.6899 11.755V11.7549Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const CoachedInIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "29", height: "28", fill: "none" }}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
    >
      <rect x="0.5" width="28" height="28" rx="14" fill="#008B07" />
      <path
        d="M14.4998 21.7077C18.757 21.7077 22.2082 18.2565 22.2082 13.9993C22.2082 9.74215 18.757 6.29102 14.4998 6.29102C10.2426 6.29102 6.7915 9.74215 6.7915 13.9993C6.7915 18.2565 10.2426 21.7077 14.4998 21.7077Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0252 6.5918C16.0002 6.95846 15.8335 7.30013 15.5835 7.5668C15.3252 7.8418 14.9418 7.9418 14.6918 8.2168C14.5168 8.4168 14.4752 8.6918 14.5252 8.95013C14.5918 9.25013 14.8002 9.47513 14.8668 9.76679C14.9335 10.0668 14.8668 10.3668 14.8835 10.6751C14.9002 11.0168 14.9335 11.3668 14.9168 11.7085C14.8918 12.3585 14.4752 12.9418 13.8835 13.2001C13.6335 13.3085 13.3418 13.3751 13.1668 13.5918C13.0002 13.7918 12.9835 14.0751 12.8335 14.2835C12.6668 14.5335 12.3252 14.6585 12.0335 14.5668C11.7502 14.4835 11.5585 14.2335 11.3168 14.0835C11.0418 13.9168 10.7085 13.8501 10.3835 13.8418C10.0418 13.8335 9.69184 13.8918 9.35017 13.9418C8.68351 14.0501 7.9085 14.1668 7.3335 13.7335"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6492 21.0174C13.6325 20.6757 13.5992 20.3257 13.6159 19.9841C13.6409 19.3341 14.0575 18.7507 14.6492 18.4924C14.8992 18.3841 15.1909 18.3174 15.3659 18.1007C15.5325 17.9007 15.5492 17.6174 15.6992 17.4091C15.8659 17.1591 16.2075 17.0341 16.4992 17.1257C16.7825 17.2091 16.9742 17.4591 17.2159 17.6091C17.4909 17.7757 17.8242 17.8424 18.1492 17.8507C18.4909 17.8591 18.8409 17.8007 19.1825 17.7507C19.8492 17.6424 20.5058 17.4174 21.0808 17.8507"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const TeamsCoachedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#008B07" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.585 6C17.7844 6 21.17 9.38562 21.17 13.585C21.17 17.7844 17.7844 21.17 13.585 21.17C9.38562 21.17 6 17.7844 6 13.585C6 9.38562 9.38562 6 13.585 6ZM10.6455 17.4168L8.44093 16.2882L8.0473 17.863L10.0157 19.9889L11.6167 19.7002L10.6457 17.4169L10.6455 17.4168ZM8.7296 12.4302L8.51966 9.96305L6.97112 10.4618L6.20997 13.2438L7.28604 14.4511L8.7296 12.4302ZM13.7425 8.80835L11.4854 7.81103L12.4565 6.4988L15.3174 6.68249L16.131 8.0997L13.7425 8.80835ZM18.4143 12.3253L18.598 9.83197L20.1728 10.3307L20.9339 13.1128L19.8316 14.3463L18.4144 12.3253H18.4143ZM16.9182 17.1546L19.1228 16.026L19.5165 17.6008L17.5481 19.7267L15.947 19.438L16.9181 17.1547L16.9182 17.1546ZM13.5849 10.9869L16.3144 12.9815L15.2646 16.1835H11.905L10.8552 12.9815L13.5849 10.9869Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const FormationsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "28", height: "28", fill: "none" }}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect width="28" height="28" rx="14" fill="#008B07" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.585 6C17.7844 6 21.17 9.38562 21.17 13.585C21.17 17.7844 17.7844 21.17 13.585 21.17C9.38562 21.17 6 17.7844 6 13.585C6 9.38562 9.38562 6 13.585 6ZM10.6455 17.4168L8.44093 16.2882L8.0473 17.863L10.0157 19.9889L11.6167 19.7002L10.6457 17.4169L10.6455 17.4168ZM8.7296 12.4302L8.51966 9.96305L6.97112 10.4618L6.20997 13.2438L7.28604 14.4511L8.7296 12.4302ZM13.7425 8.80835L11.4854 7.81103L12.4565 6.4988L15.3174 6.68249L16.131 8.0997L13.7425 8.80835ZM18.4143 12.3253L18.598 9.83197L20.1728 10.3307L20.9339 13.1128L19.8316 14.3463L18.4144 12.3253H18.4143ZM16.9182 17.1546L19.1228 16.026L19.5165 17.6008L17.5481 19.7267L15.947 19.438L16.9181 17.1547L16.9182 17.1546ZM13.5849 10.9869L16.3144 12.9815L15.2646 16.1835H11.905L10.8552 12.9815L13.5849 10.9869Z"
        fill="white"
      />
    </SvgIcon>
  );
};
